import {
  OptSideLayoutPortalContainer,
  OptSideLayoutPortalContent,
} from "@optsol/react";
import { Route, Switch } from "react-router-dom";
import { Rotas } from ".";
import { GridTransferirPassageiros } from "../paginas/transferir-passageiros/ListarTransferirPassageiros/GridTransferirPassageiros";

export const TransferirPassageirosRoutes = () => {
  return (
    <OptSideLayoutPortalContainer>
      <OptSideLayoutPortalContent>
        <Switch>
          <Route exact path={Rotas.TransferirPassageiros.Principal}>
            <GridTransferirPassageiros />
          </Route>
        </Switch>
      </OptSideLayoutPortalContent>
    </OptSideLayoutPortalContainer>
  );
};
